import { FC } from "react";
import styles from "./climbing_stairs.module.scss";
const ClimbingStairsSpinner: FC = () => {
  return <div className={styles.loader} />;
};

export default ClimbingStairsSpinner;
